import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from "lodash/get";
import CarouselArrows from 'shared-components/carousel/CarouselArrows';
let Slider = '';
import LazyLoad from 'react-lazyload';

const cloudinaryLink = 'https://img.peerspace.com/image/upload/c_crop,g_custom/g_auto,c_fill,q_auto,f_auto';

export default class CarouselSwipe extends Component {
  constructor (props) {
    super(props);
    this.renderImgUrl = this.renderImgUrl.bind(this);
    this.onError = this.onError.bind(this);
    this.state = {
      firstInteraction: false,
      activeIndex: 0
    };
    this.renderCarouselIndicators = this.renderCarouselIndicators.bind(this);
    this.renderCarouselIndicatorsPaginated = this.renderCarouselIndicatorsPaginated.bind(this);
    this.touchStart = this.touchStart.bind(this);
    this.preventTouch = this.preventTouch.bind(this);
    this.handleCarouselEventAnalytics = this.handleCarouselEventAnalytics.bind(this);
    this.handleBeforeChange = this.handleBeforeChange.bind(this);
    this.handleAfterChange = this.handleAfterChange.bind(this);
    this.imageRefs = {};
    this.SliderRef;
  }

  componentDidMount () {
    // this.setState({ loaded: true });
    import('react-slick')
      .then((module) => {
        Slider = module.default;
      })
      .catch(error => console.log(error));

    const { swipeableCarousel } = this.refs;
    swipeableCarousel.addEventListener('touchstart', this.touchStart);
    swipeableCarousel.addEventListener('touchmove', this.preventTouch, { passive: false });
  }

  componentWillUnmount () {
    const { swipeableCarousel } = this.refs;
    swipeableCarousel.removeEventListener('touchstart', this.touchStart);
    swipeableCarousel.removeEventListener('touchmove', this.preventTouch, { passive: false });
  }

  touchStart (e) {
    this.firstClientX = e.touches[0].clientX;
  }

  preventTouch (e) {
    const minValue = 5; // threshold

    this.clientX = e.touches[0].clientX - this.firstClientX;
    // Vertical scrolling does not work when you start swiping horizontally.
    if (Math.abs(this.clientX) > minValue) {
      e.preventDefault();
      e.returnValue = false;
      return false;
    }
  }

  onError (e) {
    e.currentTarget.src = 'https://assets.peerspace.com/listing-placeholder.svg?v=rb';
  }

  renderCarouselIndicators () {
    if (!this.props.listing) return;
    const { activeIndex } = this.state;
    const { listing: { images = [] } } = this.props;
    return images.map((el, idx) => {
      const indicatorClass = idx !== activeIndex ? "swipeable-carousel-indicator" : "swipeable-carousel-indicator active";
      return (<li className={indicatorClass} />);
    });
  }

  renderCarouselIndicatorsPaginated () {
    const { activeIndex } = this.state;
    const { listing: { images = [] } } = this.props;
    const indicatorDots = [...Array(5).keys()];
    if (activeIndex < 3) {
      return indicatorDots.map((el, idx) => {
        let className = 'swipeable-carousel-indicator';
        className += activeIndex === idx ? ' active' : '';
        className += 4 === idx ? ' endcap' : '';
        return (<li className={className} />);
      });
    }
    if (activeIndex >= images.length - 2) {
      const adjustedIndex = 4 - (images.length - 1 - activeIndex);
      return indicatorDots.map((el, idx) => {
        let className = 'swipeable-carousel-indicator';
        className += adjustedIndex === idx ? ' active' : '';
        className += 0 === idx ? ' endcap' : '';
        return (<li className={className} />);
      });
    }
    return indicatorDots.map((el, idx) => {
      let className = 'swipeable-carousel-indicator';
      className += idx === 2 ? ' active' : '';
      className += idx === 0 || idx === 4 ? ' endcap' : '';
      return (<li className={className} />);
    });
  }

  renderImgUrl (imgId, width) {
    const img = imgId ? `${cloudinaryLink},w_${width},ar_16:9/${imgId}` : 'https://assets.peerspace.com/listing-placeholder.svg?v=rb';
    return img;
  }

  handleBeforeChange (currentSlide, nextSlide) {
    const { listing: { images = [] } } = this.props;

    const insertImages = (slideNumber) => {
      const preloadImage = get(images, `${slideNumber}.external_id`, '');
      const imgId = this.imageRefs[slideNumber].getAttribute('data-id');
      const imgs = document.querySelectorAll(`[data-id="${imgId}"]`);
      imgs.forEach((img) => {
        img.src = this.renderImgUrl(preloadImage, 650);
      });
    };

    if (images.length) {
      let direction;

      if (nextSlide > currentSlide) {
        direction = 'right';
      }

      if (0 === currentSlide && nextSlide === images.length - 1) {
        direction = 'left';
      }

      if (nextSlide < currentSlide) {
        direction = 'left';
      }

      const slideNumber = 'right' === direction ? nextSlide + 1 : nextSlide - 1;

      if (this.imageRefs[slideNumber]) {
        insertImages(slideNumber);
      }
    }
  }

  handleAfterChange (currentSlide) {
    setTimeout(() => this.setState({ activeIndex: currentSlide }), 10);
    if (!this.state.firstInteraction) {
      this.handleCarouselEventAnalytics();
      setTimeout(() => this.setState({ firstInteraction: true }), 10);
    }
    if (this.SliderRef && this.SliderRef.innerSlider) {
      this.SliderRef.innerSlider.clickable = true;
    }
  }

  handleCarouselEventAnalytics () {
    if (!this.state.clickedOnce && this.props.source && analyticsIntegrations.photoCarouselInteraction) {
      analyticsIntegrations.photoCarouselInteraction(this.props.listing._id, this.props.source);
    }
  }

  render () {
    const { listing: { images = [] }, source = '' } = this.props;
    const isMobile = this.props.openInSameTab;
    const sourceId = source.split(' ').join('-');

    return (
      <div className="swipeable-carousel" ref="swipeableCarousel">
        <div className="carousel">
          {
            !Slider &&
            <img
              style={{ width: '100%' }}
              className="swipeable-carousel-img img-responsive"
              src={this.renderImgUrl(get(images, '0.external_id', ''), 650)}
              alt="peerspace"
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = 'https://assets.peerspace.com/listing-placeholder.svg?v=rb';
              }}
            />
          }
          {
            Slider &&
            <Slider
              ref={(ref) => this.SliderRef = ref}
              slidesToShow={1}
              slidesToScroll={1}
              speed={350}
              infinite
              swipeToSlide
              beforeChange={this.handleBeforeChange}
              afterChange={this.handleAfterChange}
              prevArrow={<CarouselArrows additionalClassName="search-arrows" noOutline isHidden={isMobile} />}
              nextArrow={<CarouselArrows additionalClassName="search-arrows" noOutline direction="right" isHidden={isMobile} />}
            >
              {
                images.map((img, index) => {
                  const imgExternalId = get(img, 'external_id', '');
                  if ((2 > index) || (index === images.length - 1)) {
                    return (
                      <LazyLoad
                        key={`${imgExternalId}-${sourceId}`}
                        offset={50}
                        minHeight={120}
                        scrollContainer={this.props.scrollContainer}
                        resize={true}
                        once
                      >
                        <img
                          key={`${imgExternalId}-${sourceId}`}
                          data-id={`${imgExternalId}-${sourceId}`}
                          className="swipeable-carousel-img img-responsive"
                          src={this.renderImgUrl(get(img, 'external_id', ''), 650)}
                          alt="peerspace"
                          style={{ width: '100%' }}
                        />
                      </LazyLoad>
                    );
                  }
                  return (
                    <LazyLoad
                      key={`${imgExternalId}-${sourceId}`}
                      offset={50}
                      minHeight={120}
                      scrollContainer={this.props.scrollContainer}
                      resize={true}
                      once
                    >
                      <img
                        key={`${imgExternalId}-${sourceId}`}
                        data-id={`${imgExternalId}-${sourceId}`}
                        ref={(ref) => this.imageRefs[index] = ref}
                        className="swipeable-carousel-img img-responsive"
                        alt="peerspace"
                        style={{ width: '100%' }}
                      />
                    </LazyLoad>
                  );
                })}
            </Slider>
          }
          <ul className="swipeable-carousel-indicators" ref="carouselIndicators">
            {5 < images.length ? this.renderCarouselIndicatorsPaginated() : this.renderCarouselIndicators()}
          </ul>
        </div>
      </div>
    );
  }
}

CarouselSwipe.propTypes = {
  images: PropTypes.array,
  listing: PropTypes.object,
  source: PropTypes.string,
  openInSameTab: PropTypes.bool,
  scrollContainer: PropTypes.string
};
